export default __webpack_public_path__ + "static/media/clientes1.25082b14.png";